(() => {
  const root = document.querySelector('[data-blog-root]');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('[data-blog-card]'));
  const buttons = Array.from(root.querySelectorAll('.asif-blog__filters button'));
  const search = root.querySelector('[data-blog-search]');
  const status = root.querySelector('[data-blog-status]');
  const empty = root.querySelector('[data-blog-empty]');
  const more = root.querySelector('[data-blog-more]');
  const curatedLabel = root.querySelector('[data-blog-curated-label]');
  const archiveDivider = root.querySelector('[data-blog-archive-divider]');
  const initialLimit = 15;
  const batchSize = 12;
  let activeCategory = 'all';
  let visibleLimit = initialLimit;

  const normalize = (value) => value
    .toLocaleLowerCase('de')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const categoryFromUrl = new URL(window.location.href).searchParams.get('category');
  if (categoryFromUrl && buttons.some((button) => button.value === categoryFromUrl)) {
    activeCategory = categoryFromUrl;
  }

  const updateStatus = (count) => {
    if (!status) return;
    const template = count === 1 ? root.dataset.resultOne : root.dataset.resultMany;
    status.textContent = template.replace('__COUNT__', String(count));
  };

  const updateUrl = () => {
    const url = new URL(window.location.href);
    if (activeCategory === 'all') url.searchParams.delete('category');
    else url.searchParams.set('category', activeCategory);
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const render = ({ updateHistory = false } = {}) => {
    const query = normalize(search?.value.trim() || '');
    const isFiltered = activeCategory !== 'all' || Boolean(query);
    const matching = cards.filter((card) => {
      const categoryMatches = activeCategory === 'all' || card.dataset.category === activeCategory;
      const searchMatches = !query || normalize(card.dataset.search || '').includes(query);
      return categoryMatches && searchMatches;
    });

    cards.forEach((card) => {
      card.hidden = true;
    });
    matching.slice(0, visibleLimit).forEach((card) => {
      card.hidden = false;
    });

    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.value === activeCategory));
    });
    updateStatus(matching.length);
    if (empty) empty.hidden = matching.length !== 0;
    if (more) more.hidden = matching.length <= visibleLimit;
    if (curatedLabel) curatedLabel.hidden = isFiltered;
    if (archiveDivider) archiveDivider.hidden = isFiltered;
    root.classList.toggle('asif-blog--filtered', isFiltered);
    if (updateHistory) updateUrl();
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      activeCategory = button.value;
      visibleLimit = initialLimit;
      render({ updateHistory: true });
    });
  });

  search?.addEventListener('input', () => {
    visibleLimit = initialLimit;
    render();
  });

  more?.addEventListener('click', () => {
    visibleLimit += batchSize;
    render();
  });

  render();
})();
